import {
    deepCopyClassName,
    IoCContainer,
    ISettingsStorage,
    SettingsBase,
    WebCoreIoCKeys,
} from '@lmnop/web-core';
import {
    IAppSettings
} from './app-settings.interface';
import { WebsiteCoreIoCKeys, WebsiteCoreSettings } from '@lmnop/website-core/website-core-src';

export class AppSettings extends SettingsBase implements IAppSettings {
    constructor() {
        super();

        /**
         * itt kell példányosítani/inicializálni a deepCopyClassName() dekorátorral ellátott property-ket
         * pl.: this.array = [], this.dictionary = {}
         */
        this.core = new WebsiteCoreSettings();
    }

    /**
     * minden class, array, object és dictionary (Record) type fölé kell a deepCopyClassName() dekorátor
     * class, array, object esetén: deepCopyClassName(type)
     * dictionary (Record) esetén: deepCopyClassName(valueType, keyType)
     * FONTOS: a dekorátort sima ts class esetén is rá kell rakni a felsorolt típusú propertykre (pl. WebPageArea class)
     */
    @deepCopyClassName(WebsiteCoreSettings)
    public core: WebsiteCoreSettings;

    public extensionChromeStoreUrlSpoilerProtection: string = '';
    public extensionFirefoxStoreUrlSpoilerProtection: string = '';

    public init(): void {
        let settingsStorage: ISettingsStorage = IoCContainer.get(WebCoreIoCKeys.ISettingsStorage);
        this.core = IoCContainer.get(WebsiteCoreIoCKeys.IWebsiteCoreSettings);
        this.core.init();

        settingsStorage.initSettingsStorage(this, this.core);

        this.setDefaultValues();
        this.updateSettingsInStorage();
    }

    public getModuleSettingName(): string {
        return 'AppSettings';
    }


    public setDefaultValues(): void {
        this.core.setDefaultValues();
    }

    public translateDefaultValues(): void {
        this.core.translateDefaultValues();
    }
}
